import { get } from "../../../api/axios-client";
import { User } from "../models/authTypes";

const controllerUrl = "api/ApplicationUser/";

export const ApplicationUserAPI = {
  getUserByUserName: async (userName: string): Promise<User | null> => {
    const url = `${controllerUrl}GetAppUserByUserName?searchTerm=${userName}`;
    const { data } = await get(url);
    return data;
  },
};
export default ApplicationUserAPI;
